import type { SyncState } from "@/types/sync.types";
import { atom } from "jotai";

export const syncStateAtom = atom<SyncState>({
  isRunning: false,
  modalOpen: false,
  status: "",
  error: null,
  progress: { page: 0, activities: 0 },
  events: [],
  lastSyncedAt: null,
  lastResult: null,
  syncAttemptCompleted: false,
  hasAutoRunOnce: false,
});

export const syncIsRunningAtom = atom((get) => get(syncStateAtom).isRunning);

export const syncModalOpenAtom = atom(
  (get) => get(syncStateAtom).modalOpen,
  (_get, set, next: boolean) =>
    set(syncStateAtom, (s) => ({ ...s, modalOpen: next })),
);

export const syncLastSyncedAtAtom = atom(
  (get) => get(syncStateAtom).lastSyncedAt,
);

export const syncAttemptCompletedAtom = atom(
  (get) => get(syncStateAtom).syncAttemptCompleted,
);
